<template>
  <div 
    class="back-to-top" 
    :class="{ visible: isVisible }"
    @click="scrollToTop"
    v-show="isVisible"
    title="回到顶部"
  >
    <i class="fas fa-chevron-up"></i>
  </div>
</template>

<script>
export default {
  name: 'BackToTop',
  data() {
    return {
      isVisible: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      // 当页面滚动超过200px且页面高度大于窗口高度时显示按钮
      const scrollTop = window.pageYOffset
      const documentHeight = document.documentElement.scrollHeight
      const windowHeight = window.innerHeight
      
      this.isVisible = scrollTop > 200 && documentHeight > windowHeight + 100
    },
    scrollToTop() {
      // 瞬间滚动到顶部，无动画
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css');

.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;  /* 大屏幕默认在浏览器右下角 */
  width: 50px;
  height: 50px;
  background: #667eea;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  opacity: 0;
  visibility: hidden;
  z-index: 999;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.back-to-top.visible {
  opacity: 1;
  visibility: visible;
}

.back-to-top:hover {
  background: #5a6fd6;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.back-to-top:active {
  transform: translateY(0);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.back-to-top i {
  font-size: 18px;
}

/* 响应式设计 - 屏幕宽度小于等于1400px时，如果会遮挡移动端按钮，就移到公告栏右侧 */
@media (max-width: 1400px) and (min-width: 1200px) {
  .back-to-top {
    /* 移到页面顶部搜索区域，公告栏右边 */
    bottom: auto;
    top: 180px;       /* 导航栏高度(70px) + 搜索区域顶部间距(~110px) */
    right: 10px;      /* 紧贴公告栏右边 */
    width: 45px;
    height: 45px;
    z-index: 999;
  }
  
  .back-to-top i {
    font-size: 16px;
  }
}

/* 小屏幕时（公告栏也隐藏了），回到原位置 */
@media (max-width: 1199px) {
  .back-to-top {
    bottom: 30px;
    right: 30px;
  }
}

/* 移动端进一步调整 */
@media (max-width: 768px) {
  .back-to-top {
    bottom: 20px;
    right: 20px;
    width: 45px;
    height: 45px;
  }
  
  .back-to-top i {
    font-size: 16px;
  }
}
</style> 